import { render } from "./ModalPaymentMethodAdd.vue?vue&type=template&id=f659dbcc&scoped=true"
import script from "./ModalPaymentMethodAdd.vue?vue&type=script&lang=js"
export * from "./ModalPaymentMethodAdd.vue?vue&type=script&lang=js"

import "./ModalPaymentMethodAdd.vue?vue&type=style&index=0&id=f659dbcc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f659dbcc"]])

export default __exports__